<template>
  <div class="orgBox">
    <div class="organ">
      <!-- <div class="orgTopbg">
        <img class="orgbg" src="../../assets/images/pageHome/topTitle.png" alt />
        <div class="orgTop">社会组织发展情况</div>
          <div class="back" @click="back">
        <img src="../../assets/images/back.png" alt />
        <span>返回</span>
      </div>
      </div> -->
      <div class="top">
        <div class="tit">社会组织发展情况</div>
        <div class="border"></div>
        <div class="back"
             @click="back">
          <img src="../../assets/images/back.png"
               alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="orgCenter">
        <div class="orgLeft">
          <div class="orgTab">
            <img class="orgImgs"
                 @click="tochange"
                 src="../../assets/images/orgTab.png"
                 alt />
            <div class="orgBoxz">
              <div :class="[item.flage ? 'active':'orgList']"
                   v-for="(item,index) in orgList"
                   :key="index"
                   @click="changeName(item)">{{item.addressName}}</div>
            </div>
          </div>
        </div>
        <div class="orgRight">
          <div class="orgTabers">
            <div :class="[orgchange5?'orgTaberac1':'orgTaber']"
                 @click="orgchanges(5)">总分排行</div>
            <div :class="[!orgchange?'orgTaber':'orgTaberac']"
                 @click="orgchanges(0)">组织运行指数</div>
            <div :class="[!orgchange1?'orgTaber':'orgTaberac']"
                 @click="orgchanges(1)">服务活力指数</div>
            <div :class="[!orgchange2?'orgTaber':'orgTaberac']"
                 @click="orgchanges(2)">公益评价指数</div>
            <div :class="[!orgchange3?'orgTaber':'orgTaberac']"
                 @click="orgchanges(3)">堡垒指数</div>
            <div :class="[!orgchange4?'orgTaber':'orgTaberac4']"
                 @click="orgchanges(4)">专业指数</div>
          </div>
          <div class="orgRightop"
               style="padding:0 21px;margin-top:20px">
            <!-- <img class="orgbg" mode="widthFix" src="../../assets/images/nrq.png" alt=""> -->
            <div class="orgConter"
                 v-for="(item,index) in list"
                 :key="index">
              <div class="orgConLeft" @click="xq(item.id)">
                <div style="margin-top:29px">{{item.orgName}}</div>
                <div class="orgNewtxt"
                     style="padding-bootom:3px">
                  <img class="addressImg"
                       style="margin-right:5px"
                       src="../../assets/images/addressImg.png"
                       alt />
                  <div>{{item.address}}</div>
                </div>
              </div>

              <div class="orgConRight">
                <!-- <img class="orgAddress" src="../../assets/images/govList.png" alt /> -->
                <div class="orgBoxs">
                  <div class="orgNewbox"></div>
                  <div class="score">{{item.score}}</div>
                </div>
              </div>
            </div>
            <div v-if="total==0"
                 style="color:#FFE1CE;font-size:30px;font-weight:600;margin-top: 200px;text-align: center;">暂无相关数据</div>
          </div>
          <Pagination style="bottom:14px"
                      v-if="total>0"
                      :total="total"
                      :page="page"
                      :size="6"
                      @pagination="fetchData" />
        </div>
      </div>
    </div>
    <div class="orgbg"></div>
  </div>
</template>
<script>
import baseUrl from '../../config/config'
import axios from 'axios'
import Pagination from '@/components/pagination'
export default {
  name: "",
  components: {
    Pagination
  },

  data () {
    return {
      orgchange: true,
      orgchange1: false,
      orgchange2: false,
      orgchange3: false,
      orgchange4: false,
      orgchange5: false,
      page: 1,
      typeD: '',
      typeO: '',
      charitable: '',//是否慈善组织
      party: '',//是否党组织
      dictId: '',
      ltype: '',//类型
      keyLists: '',
      ltypes: '',
      keyList: '',
      ltypez: '',
      keyListz: '',
      fLists: '',
      fListz: '',
      ftype: '',
      list: [],
      baseUrl: baseUrl,
      total: 0,
      indexNumberType: 0,
      currentPage: 0,
      // total:10,
      searchForm: {
        pageSize: 1
      },
      listLoading: false,
      type: '',
      input: '',
      value: '',
      orgList: [],
      orgName: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    }
  },
  created () {
        this.orgchange = false
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = true
        this.indexNumberType = 5
        this.getList()
    if (this.$route.query.indexNumberType) {
      this.indexNumberType = Number(this.$route.query.indexNumberType)
      let item = this.$route.query.indexNumberType
      if (item == 1) {
        console.log(111)
        this.orgchange = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 1

      } else if (item == 2) {
        this.orgchange1 = true
        this.orgchange = false
        this.orgchange2 = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 2

      } else if (item == 3) {
        this.orgchange2 = true
        this.orgchange1 = false
        this.orgchange = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 3

      } else if (item == 4) {
        this.orgchange3 = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 4

      } else if (item == 5) {
        this.orgchange4 = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange = false
        this.orgchange3 = false
        this.orgchange5 = false
        this.indexNumberType = 5

      }
    }
    console.log('jinlai')
    this.orgList.map((v) => {
      v.flage = false
    })
    this.getTab()
    this.getList()
    this.getqueryDictByKey('teamwordBigType')
    this.getqueryDictByKeyz('serviceType')
    // this.ltypes = 0
  },

  methods: {
    tochange () {
      this.orgchange = true
      this.orgchange1 = false
      this.orgchange2 = false
      this.orgchange3 = false
      this.orgchange4 = false
      this.indexNumberType = 1
      this.street = ''
      this.orgList.map((v) => {
        console.log(v.flage, 'v.flage')
        v.flage = false
      })
      this.street = ''
      this.list = []
      this.getList()
    },
    // 返回
    back () {
      this.$router.go(-1);
    },
    orgchanges (item) {
      console.log(item, 'iten=======<')
      if (item == 0) {
        console.log(111)
        this.orgchange = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 0
        this.getList()
      } else if (item == 1) {
        this.orgchange1 = true
        this.orgchange = false
        this.orgchange2 = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 1
        this.getList()
      } else if (item == 2) {
        this.orgchange2 = true
        this.orgchange1 = false
        this.orgchange = false
        this.orgchange3 = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 2
        this.getList()
      } else if (item == 3) {
        this.orgchange3 = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange = false
        this.orgchange4 = false
        this.orgchange5 = false
        this.indexNumberType = 3
        this.getList()
      } else if (item == 4) {
        this.orgchange4 = true
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange = false
        this.orgchange3 = false
        this.orgchange5 = false
        this.indexNumberType = 4
        this.getList()
      } else if (item == 5) {
        this.orgchange5 = true
        this.orgchange4 = false
        this.orgchange1 = false
        this.orgchange2 = false
        this.orgchange = false
        this.orgchange3 = false
        this.indexNumberType = 5
        this.getList()
      }
    },
    //清空
    clear () {
      this.orgName = "",
        this.orgType = "",
        this.serviceCategory = "",
        this.party = "",
        this.charitable = "",
        //  this.street="",
        this.ltype = '',
        this.ltypes = '',
        this.ltypez = '',
        this.ftype = '',
        this.typeD = '',
        this.typeO = ''
    },
    //是否有党组织
    changeD (item) {
      console.log(item.target.value, 'item')
      this.party = item.target.value
    },
    //是否慈善组织
    changeO (item) {
      console.log(item.target.value, 'item')
      this.charitable = item.target.value
    },
    //类型选择
    changeKey (item) {
      console.log(item.target.value, 'item')
      this.getqueryDictByKeys('teamwordType')
    },
    //子类型选择
    changeKeys ($event) {
      console.log($event.target.value, 'items')
    },
    //服务类型
    changeFtype ($event) {
      console.log($event.target.value, 'items')
      this.getqueryDictByKeyzi('projectCategory')
    },
    //子服务类型
    changeFtypes ($event) {
      console.log($event.target.value, 'items')
    },
    getinput (e) {
      this.orgName = e.target.value;
      console.log(this.input)
    },
    search () {
      this.orgName = this.input
      this.getList()
    },
    //子服务类型下拉框
    getqueryDictByKeyzi (me) {
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/dictController/queryDictByKeyParent', {
        key: me
      })
        .then(function (response) {
          console.log(response, '类型');
          that.fListz = response.data
          // that.ltypez = that.fLists[0].dictId
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //服务类型下拉框
    getqueryDictByKeyz (me) {
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/dictController/queryDictByKeyParent', {
        key: me
      })
        .then(function (response) {
          console.log(response, '类型');
          that.fLists = response.data
          // that.ltypez = that.fLists[0].dictId
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //类型下拉框
    getqueryDictByKey (me) {
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/dictController/queryDictByKeyParent', {
        key: me
      })
        .then(function (response) {
          console.log(response, '类型');
          that.keyList = response.data
          // that.ltype = that.keyList[0].dictId
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //子类型下拉框
    getqueryDictByKeys (me) {
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/dictController/queryDictByKeyParent', {
        key: me,
        parentId: this.dictId
      })
        .then(function (response) {
          console.log(response, '类型');
          that.keyLists = response.data
          // that.ltypes = that.keyLists[0].dictName
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //左侧列表
    getTab () {
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/sysAddressController/selecteAddressByCityTeamWork', {
        parentId: 330102
      })
        .then(function (response) {
          console.log(response, '左侧列表');
          that.orgList = response.data
          that.orgList.map((v) => {
            v.flage = false
          })
          console.log(that.orgList, 'that.orgList')
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //列表
    getList () {
      console.log(baseUrl, 'baseUrl')
      this.listLoading = true
      let that = this
      axios.post(this.baseUrl.baseUrl + '/system/wechat/kyyOrganizationPcController/selectKyyOrgDevelopmentList', {
        page: this.page,
        indexNumberType: this.indexNumberType,
        street: this.street,
        limit: 5
      })
        .then(function (response) {
          console.log(response.data.lastPage, 'list')
          console.log(response, '列表');
          that.total = response.data.total
          console.log(' that.total=====》', response.data.total)
          that.list = response.data.list
          console.log(response.data.lastPage, 'list')
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fetchData (e) {
      console.log(e)
      this.page = e
      this.list = []
      this.getList()
    },
    handleCurrentChange (cpage) {
      this.currentPage = cpage || 9;
    },
    jumpFirstPage () {
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit('handleCurrentChange', 1);
    },
    jumpLastPage () {
      let font = this.$refs.pagination
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    changeName (item) {
      console.log(item, 'item')
      this.orgList.map((v) => {
        console.log(v.flage, 'v.flage')
        v.flage = false
        if (item.addressName == v.addressName) {
          v.flage = true
        }
      })
      this.street = item.id
      this.list = []
      this.getList()
    },
    xq(id){
        this.$router.push({
              path: "/socialorgDetails",
              query: {
                id,
              },
            });
    }
  }
}
</script>
<style lang="less" scoped>
.orgbg {
  // // position: absolute;
  // // top: -100px;
  // // left: -100px;
  // // width: 1790px;
  // // height: 900px;
  // // width: 1765px;
  // // height: 1000px;
  // width: 1630px;
  // height: 900px;
  // // background: url("../../assets/images/nrq2.png") no-repeat center/100% 100%;
  // position: absolute;
  // right: 6px;
  // bottom: 6px;
  // pointer-events: none;
  // background: pink;
  // z-index: 5;
  // z-index: 5;
  width: 1615px;
  height: 937px;
  position: absolute;
  right: 49px;
  bottom: 47px;
  pointer-events: none;
  background: url("../../assets/images/nrq2.png") no-repeat center/100% 100%;
}
.back {
  position: absolute;
  top: 31px;
  right: 43px;
  font-size: 24px;
  font-weight: 400;
  color: #1080d0;
  cursor: pointer;
  img {
    width: 20px;
    height: 21px;
    margin-right: 9px;
  }
}
.orgBox {
  background: #000;
}
.shap {
  width: 18px;
  height: 18px;
  position: absolute;
  right: 20px;
  top: 16px;
}
select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url("../../assets/images/orgup.png") no-repeat scroll right center /
    15% 21%;
  // /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  padding: 0 10px;
  margin: 0 10px;
  // width: 118px;
  height: 40px;
  background-color: #713608;
  opacity: 0.8;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.9;
  padding-right: 14px;
}
select::-ms-expand {
  display: none;
}
input {
  background: none;
  outline: none;
  border: 0px;
}
input::-webkit-input-placeholder {
  line-height: 24px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.3;
}
.organ {
  height: 1080px;
  // background: url("../../assets/images/pageHome/personNeedList_centerBg.png")
  //   no-repeat center/100% 100%;
}
.orgTab {
  width: 199px;
  height: 100%;
  img {
    padding: 0;
    margin: 0;
  }
  .orgImgs {
    width: 201px;
    height: 90px;
    cursor: pointer;
  }
  .orgBoxz {
    padding-bottom: 1px;
    height: 817px;
    margin-top: -5px;
    padding: 18px 0;
    background: url("../../assets/images/orgTaber.png") no-repeat center/100%
      100%;
    // background: #0e79e4;
  }
  .orgList:first-child {
    margin-top: 0;
    // padding-top: 16px;
    cursor: pointer;
  }
  .active:first-child {
    margin-top: 0;
    // padding-top: 16px;
    cursor: pointer;
  }
  .orgList {
    font-size: 23px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 23px;

    margin-bottom: 33px;
    text-align: center;
    opacity: 0.6;
    cursor: pointer;
  }
  .active {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 24px;
    margin: 35px 0;
    text-align: center;
    opacity: 1;
    cursor: pointer;
  }
}
.orgConter {
  padding-left: 30px;
  background: url("../../assets/images/govList.png") no-repeat center/100% 100%;
  height: 145px;
  widows: 98%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
  .orgConLeft {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    // text-align: center;
    // line-height: 99px;
    .addressImg {
      width: 20px;
      height: 20px;
    }
    .orgNewtxt {
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        margin-right: 6px;
      }
    }
  }
  .orgConRight {
    display: flex;
    flex-direction: row;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    // opacity: 0.4;
    line-height: 99px;
    align-items: center;
    .orgAddress {
      width: 23px;
      height: 30px;
      margin-right: 10px;
      margin-top: 35px;
    }
    .orgAddress {
      width: 20px;
      height: 22px;
    }
    .orgBoxs {
      display: flex;
      flex-direction: row;
      text-align: center;
      .score {
        font-size: 38px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        // line-height: 145px;
        // text-align: center;
        // display: flex;
        // align-items: center;
        // justify-content: flex-end;
        // padding-right:80px;
        // margin-right: 64px;
        opacity: 1 !important;
        text-align: center;
        line-height: 145px;
        width: 168px;
        height: 145px;
      }
    }
  }
}
.top {
  height: 92px;
  overflow: hidden;
  position: relative;
  background: url("../../assets/images/pageHome/topTitle.png") no-repeat
    center/100% 100%;
  .tit {
    height: 33px;
    width: 300px;
    line-height: 33px;
    margin-top: 22px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    // background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    margin-left: 823px;
  }
  .back {
    position: absolute;
    top: 31px;
    right: 43px;
    font-size: 24px;
    font-weight: 400;
    color: #fff;
    cursor: pointer;
    img {
      width: 20px;
      height: 21px;
      margin-right: 9px;
    }
  }
}
// .orgTopbg {
//   height: 80px;
//   // background-image: url("../../assets/images/pageHome/topTitle.png") no-repeat center/100% 100%;
//   .orgbg {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 80px;
//   }

//   .orgTop {
//     font-size: 32px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: #ffffff;
//     opacity: 0.91;
//     height: 80px;
//     line-height: 80px;
//     background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-image: url("../../assets/images/pageHome/topTitle.png") no-repeat
//       center/100% 100%;
//     text-align: center;
//   }
// }
.orgInput {
  width: 1000px;
  height: 50px;
  background: #502707;
  opacity: 0.8;
  border-radius: 5px;
  display: flex;
  align-content: center;
  // margin-top: 5px;
  margin-left: 5px;
  position: relative;
  .searchs {
    width: 24px;
    height: 24px;
    margin: 14px;
  }
  .orgText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.9;
    margin: 13px 0;
  }
  .block {
    margin: 0 20px;
    margin-top: 8px;
    height: 34px;
    border: 2px solid #eacb1c;
  }
  .oInput {
    height: 24px;
    margin-top: 13px;
    font-size: 22px;
    color: #ffffff;
  }
}
.set {
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  background: url("../../assets/images/set.png") no-repeat center/100% 100%;
}
.orgSearchs {
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  background: url("../../assets/images/orgSearch.png") no-repeat center/100%
    100%;
}
.orgSearch {
  display: flex;
  align-items: center;
  height: 57%;
  .typeImg {
    width: 20px;
    height: 27px;
    padding-top: 5px;
    margin: 0 9px 0 20px;
  }
  .typeText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.9;
  }
}
.orgCenter {
  display: flex;
  flex-direction: row;
}
.orgItext {
  display: flex;
  flex-direction: row;
  .oText {
    width: 24%;
  }
}
.orgLeft {
  margin-left: 30px;
  // margin-top: 4px;
  width: 10%;
  height: 75.6%;
  /deep/.el-aside {
    background-color: transparent !important;
  }
}
/deep/.el-menu {
  background-color: transparent !important;
}
.el-menu {
  width: 200px;
  height: 909px;
  background: url("../../assets/images/orgLeft.png") no-repeat center/100% 100%;

  .el-submenu {
    /deep/ .el-submenu__title {
      width: 198px;
      height: 90px;
      background: url("../../assets/images/orgLeft1.png") no-repeat center/100%
        100%;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      padding: 0;
      text-align: center;
      line-height: 90px;
      opacity: 0.5;
    }
    /deep/ .el-submenu__title:hover {
      opacity: 1;
    }
    /deep/ .el-menu-item-group__title:hover {
      background: url("../../assets/images/orgLeft2.png") no-repeat center/100%;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 57px;
      line-height: 57px;
      text-align: center;
    }
    /deep/.el-menu-item-group__title {
      height: 57px;
      line-height: 57px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 0 !important;
      text-align: center;
    }
    /deep/.el-menu-item-group__title:hover {
      opacity: 1;
    }
  }
}
.orgTabers {
  display: flex;
  flex-direction: row;
  margin-left: 17px;
  .orgTaber {
    background: url("../../assets/images/orgCenters.png") no-repeat center/100%;
    width: 277px;
    height: 79px;
    line-height: 79px;
    text-align: center;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.8;
    margin-left: -6px;
    cursor: pointer;
  }
  .orgTaber:first-child {
    background: url("../../assets/images/orgActive.png") no-repeat center/100%;
    width: 277px;
    height: 79px;
    line-height: 79px;
    text-align: center;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.8;
    cursor: pointer;
  }
  .orgTaber:last-child {
    background: url("../../assets/images/navBg2.png") no-repeat center/100%;
    width: 277px;
    height: 79px;
    line-height: 79px;
    text-align: center;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.8;
    cursor: pointer;
  }
  .orgTaberac1 {
    background: url("../../assets/images/navBg.png") no-repeat center/100%;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.5;
    line-height: 79px;
    text-align: center;
    width: 277px;
    height: 79px;
    margin-left: -6px;
    cursor: pointer;
  }
  .orgTaberac {
    background: url("../../assets/images/orgbg.png") no-repeat center/100%;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.5;
    line-height: 79px;
    text-align: center;
    width: 277px;
    height: 79px;
    margin-left: -6px;
    cursor: pointer;
  }
  .orgTaberac4 {
    background: url("../../assets/images/orgLast.png") no-repeat center/100%;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.5;
    line-height: 79px;
    text-align: center;
    width: 277px;
    height: 79px;
    margin-left: -6px;
    cursor: pointer;
  }
}
.orgRightop {
  height: 935px;
  margin-left: 10px;
  padding-top: 20px !important;
  position: relative;
  // background: url("../../assets/images/nrq.png") no-repeat center/100% 100%;
}
.orgRight {
  width: 1630px;
  height: 940px;
  position: relative;
  overflow: hidden;
  margin-left: 20px;

  // .orgList {
  //     margin-left: 20PX;
  //     margin-bottom: 25PX;
  //   background: url("../../assets/images/govList.png") no-repeat center/100%;
  //   width: 1594px;
  //   height: 184px;
  //   .orgRight{
  //     display: flex;
  //     flex-direction: row;
  //   }
  //   .orgLtitle {
  //     height: 34px;
  //     font-size: 36px;
  //     font-family: Source Han Sans CN;
  //     font-weight: 400;
  //     color: #ffffff;
  //     height: 113px;
  //     line-height: 113px;
  //     padding-left: 32PX;
  //   }
  //   .orgMess {
  //     display: flex;
  //     flex-direction: row;
  //     padding-left: 32PX;
  //     height: 71PX;
  //     img {
  //       width: 29px;
  //       height: 29px;
  //       margin-right: 5PX;
  //       margin-top: 2PX;
  //     }
  //     .per {
  //       font-size: 28px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 400;
  //       color: #ffffff;
  //       opacity: 0.4;
  //       height: 34PX;
  //       line-height: 28PX;
  //       margin-top: 16PX;
  //       padding-right: 20PX;
  //       margin-right: 20PX;
  //       // border-right: 1PX solid #ffffff;
  //     }
  //   }
  // }
}
</style>
